import { Interceptor } from "@core/api/interceptors/interceptor";
import { AnnouncementReceivedService } from "@domain/announcement/announcement-received-service";
import { isNotNil } from "@utils/assert";
import { AxiosResponse } from "axios";

export const getLatestAnnouncementId: (
	announcementReceivedService: AnnouncementReceivedService,
) => Interceptor<AxiosResponse> = announcementReceivedService => ({
	onFulfilled: async (response: AxiosResponse) => {
		const headerValue: string | undefined = response.headers["x-pt-latest-announcement-id"];
		if (isNotNil(headerValue)) {
			announcementReceivedService.onAnnouncementIdReceived.dispatch(headerValue);
		}
		return response;
	},
});
